
shadow.loader.init("");